import {
  ICategory,
  IResponseDetailMaterial,
} from '@/interfaces/doccen-lib/contentManagement.interface';
import { omit } from 'lodash';

export const recursiveRetrieveCategories = (
  currentLevel: number,
  finalValue: { [key: number]: Omit<ICategory, 'categories'> },
  category?: IResponseDetailMaterial['material']['category'] | null
): { [key: number]: Omit<ICategory, 'categories'> } => {
  if (!category) return finalValue;

  finalValue[currentLevel] = omit(category, 'category');

  return recursiveRetrieveCategories(
    currentLevel + 1,
    finalValue,
    category?.category
  );
};
